export default "__VITE_ASSET__DWPSs96o__"